// TODO: 假資料，換成真的後記得刪除
export const DUMMY_SERVICE_TICKET_TABLE_DATASOURCE = [
  {
    serviceName: '育樂活動',
    isActive: true,
  },
  {
    serviceName: '清潔服務',
    isActive: false,
  },
];
